import { put } from 'redux-saga/effects'
import { createFollowupAction, fetchFollowupsByOperatorAction } from '../../handles'
import { createFollowup } from '../_http/followup'

export function* createFollowupSaga(action: ReturnType<typeof createFollowupAction.request>) {
  try {
    yield createFollowup(action.payload)
    yield put(createFollowupAction.success())

    const { companyId, ownerId, operatorId } = action.payload
    yield put(fetchFollowupsByOperatorAction.request({ companyId, ownerId, operatorId, page: 1 }))
  } catch (error) {
    yield put(createFollowupAction.failure())
  }
}
